import { assetPath } from "./routes";

export const screenshots = {
  icon: assetPath("/images/app-store/Icon.png"),
  launch: assetPath("/images/app-store/LaunchScreen.png"),
  camera: assetPath("/images/app-store/screen-3.png"),
  hero: assetPath("/images/app-store/screen-1.png"),
  heroAlt: assetPath("/images/app-store/screen-2.png"),
  video: assetPath("/images/app-store/screen-4.png"),
  dualCamera: assetPath("/images/app-store/screen-5.png"),
  gallery: assetPath("/images/app-store/screen-6.png")
} as const;

export type ScreenshotKey = keyof typeof screenshots;
